import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../service/auth.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  isAuthenticated = false;
  isAdmin = false;
  isCollapsed = true; // Fermé par défaut
  isHovered = false; // Suivre l'état du hover
  selectedModule: string = 'CAC'; // Module sélectionné
  isOnModuleSelector = false;
  userEmail: string = ''; // Email de l'utilisateur pour les restrictions


  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    // Écouter les changements de taille d'écran
    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());
  }

  ngOnInit() {
    // Check initial authentication status
    this.isAuthenticated = this.authService.isAuthenticated();
    this.isAdmin = this.authService.isAdmin();
    this.userEmail = localStorage.getItem('email') || '';
    
    // Détecter le module initial
    this.detectModule(this.router.url);
    
    // Écouter les changements de route pour détecter le module
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.detectModule(event.urlAfterRedirects || event.url);
      // Re-synchroniser l'état auth pour affichage immédiat sans refresh
      this.isAuthenticated = this.authService.isAuthenticated();
      this.isAdmin = this.authService.isAdmin();
      this.userEmail = localStorage.getItem('email') || '';
    });
    
    // Subscribe to authentication status changes
    this.authService.authStatus$.subscribe(
      (isAuth: boolean) => {
        this.isAuthenticated = isAuth;
        this.isAdmin = this.authService.isAdmin();
        this.userEmail = localStorage.getItem('email') || '';
      }
    );
    
    // Initial width update
    this.updateMainWrapperWidth();
  }

  ngOnDestroy() {
    // Réinitialiser les dimensions du main-wrapper quand la sidebar est détruite
    const mainWrapper = document.querySelector('.main-wrapper');
    if (mainWrapper) {
      (mainWrapper as HTMLElement).style.width = '';
      (mainWrapper as HTMLElement).style.marginLeft = '';
    }
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    this.updateMainWrapperWidth();
  }

  onMouseEnter() {
    if (!this.isHovered) {
      this.isHovered = true;
      this.isCollapsed = false;
      this.updateMainWrapperWidth();
    }
  }

  onMouseLeave() {
    if (this.isHovered) {
      this.isHovered = false;
      this.isCollapsed = true;
      this.updateMainWrapperWidth();
    }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  selectModule(module: 'CAC' | 'CAS'): void {
    this.selectedModule = module;
    localStorage.setItem('selectedModule', module);
    if (module === 'CAC') {
      this.router.navigate(['/cac/dashboard']);
    } else {
      this.router.navigate(['/cas/dashboard']);
    }
  }

  logout(): void {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
      error: (error) => {
        // Même en cas d'erreur, on déconnecte côté client
        console.error('Erreur lors de la déconnexion:', error);
        this.authService.clearToken();
        this.router.navigate(['/login']);
      }
    });
  }

  private detectModule(url: string): void {
    this.isOnModuleSelector = url.includes('/select-module');

    if (url.includes('/cas/')) {
      this.selectedModule = 'CAS';
    } else if (url.includes('/cac/')) {
      this.selectedModule = 'CAC';
    }
  }

  private checkScreenSize() {
    if (window.innerWidth <= 768) {
      this.isCollapsed = true;
    }
  }

  private updateMainWrapperWidth() {
    // Emit event ou utiliser un service pour notifier le changement
    const mainWrapper = document.querySelector('.main-wrapper');
    if (mainWrapper) {
      const width = this.isCollapsed ? 'calc(100vw - 70px)' : 'calc(100vw - 260px)';
      (mainWrapper as HTMLElement).style.width = width;
      (mainWrapper as HTMLElement).style.marginLeft = this.isCollapsed ? '70px' : '260px';
    }
  }
}
